import {ErrorStateScheduleEnum} from '../../error-state-schedule.enum';

export enum MessageRequestErrorStatesEnum {
    GetMessageRequestFailed = ErrorStateScheduleEnum.MessageRequestStatesStartIndex,
    GetMessageRequestNoData,
    CreateMessageRequestFailed,
    UpdateMessageRequestFailed,
    GetRecipientsFailed,
    GetRecipientsNoData,
    GetKeyCodesFailed,
}
